import marketingInstance from './instance'

const deleteCoupon = (id) => {
  return marketingInstance.delete('/coupons/' + id)
}

export default deleteCoupon
